module.exports = __webpack_public_path__ + "static/media/more-vertical-lighter.3a3067ba.svg";